import FleetOverview from "components/ARC/FleetOverviewWidget";
import MissionsSummary from "components/navigation/mission/MissionsSummaryWidget";
import FleetLocationsMap from "components/map/FleetLocationsMap";
import { useOrgId } from "lib/hooks/useOrg";
import { useFleet } from "providers/FleetProvider";

const AllFleetsPage = () => {
    const { fleets } = useFleet();
    const organizationId = useOrgId();
    return (
        <div className="page-with-top-bar flex h-full min-h-0 flex-col space-y-4 overflow-y-scroll p-6">
            <MissionsSummary className="min-h-[12rem]" />
            {/* TODO: Temporary demo prototype; remove when live fleet GPS data is available. */}
            {organizationId === "r2c2" && <FleetLocationsMap />}
            <div className="flex min-h-0 w-full shrink-0 grow flex-col items-center space-y-3">
                <h3 className="w-full grow-0">Fleets</h3>
                <div className="max-h-full w-full grow space-y-3 overflow-y-scroll">
                    {fleets.map((fleet) => (
                        <FleetOverview
                            key={fleet.id}
                            id={fleet.id}
                            className="w-full grow-0"
                            fleet={fleet}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AllFleetsPage;
